import { render } from "./SideBottom.vue?vue&type=template&id=dc94d418&scoped=true"
import script from "./SideBottom.vue?vue&type=script&lang=js"
export * from "./SideBottom.vue?vue&type=script&lang=js"

import "./SideBottom.vue?vue&type=style&index=0&id=dc94d418&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc94d418"]])

export default __exports__